import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { ContentBox, FormButtons, FormError, VerificationCodeInput, InputHint, LinkButton, Notification, PortalForm } from '@portal/kit/pkg/components'
import { withTranslation } from 'react-i18next'
import { formatPhoneNumber } from '@portal/kit/pkg/helpers'

const ValidationCodeView = props => (
  <Fragment>
    {props.resendStatus === props.resendStatuses.SUCCESS && <Notification type="success" message={props.t('account.phone_number.resend_code.success')} />}
    <ContentBox title={props.t('account.edit_my_phone_number')}>
      <PortalForm onSubmit={props.handleSubmit}>
        {(props.submitError || props.resendStatus === props.resendStatuses.ERROR) && <FormError message={props.submitError || props.t('form.error')} />}
        {props.resendStatus === props.resendStatuses.LIMIT_REACHED && <FormError message={props.t('account.phone_number.resend_code.limit_reached')} />}
        <VerificationCodeInput name="code" label={props.t('account.phone_number.code.title')}>
          <InputHint>
            {props.t('account.phone_number.code.not_received', { phone_number: formatPhoneNumber(props.user.phone_number_change_request) })}
            &nbsp;
            <LinkButton onClick={props.resendCode}>{props.t('account.phone_number.code.send_back')}</LinkButton>
          </InputHint>
        </VerificationCodeInput>
        <FormButtons back={props.previousStep} submit />
      </PortalForm>
    </ContentBox>
  </Fragment>
)

ValidationCodeView.propTypes = {
  user: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
  resendCode: PropTypes.func.isRequired,
  resendStatus: PropTypes.string,
  resendStatuses: PropTypes.object.isRequired,
}

export default withTranslation()(ValidationCodeView)
